import React, { Component, Fragment } from 'react';
import './PlanMtoPerfilTabla.css'; 
import {clearErrors, getRepuestos} from '../../../redux/actions/dataactions';
import {getProgMtosInfraCliente,deleteProgMtoInfra,getProgMtosInfraClienteFiltrado} from '../../../redux/actions/infraactions';
import {postMtoInfra} from '../../../redux/actions/infraactions'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { FaArrowLeft,FaCheck,FaCheckCircle,FaFilePdf,FaPlus, FaTrash } from "react-icons/fa";
import MaterialTable from 'material-table';import MyButton from '../../../utils/MyButton';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import CircularProgress from '@material-ui/core/CircularProgress';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import PlanMtoCronoAuto from './PlanMtoCronoAuto';

import {Link} from 'react-router-dom';
import PlanMtoIndicadoresDialog from './PlanMtoIndicadoresDialog';
import { getUsuariosAsistenciales } from '../../../redux/actions/useractions';

export class PlanMtoPerfilTabla extends Component {
    
    constructor(){
        super();
        this.state={
            fecha:'',
            hora:'',
            duracion:'',
            taskElectrica:'',
            taskHidraulica:'',
            taskComunicaciones:'',
            taskGases:'',
            taskInstalaciones:'',
            observaciones:'',
            horainicio:'',
            horafinal:'',
            firmarecibe:'',
            cargorecibe:'',
            fechafinal:'',
            areaid:'',
            errors:{},
            aprobado:{},
            open:false,
            opendelete:false,
            progid:'',
            clienteid:'',
            repuestoId: '',
            repuestoId1: '',
            repuestoId2: '',
            nombrerepuesto:'',
            nombrerepuesto1:'',
            nombrerepuesto2:'',
            cantidad:0,
            cantidad1:0,
            cantidad2:0,
            costo:0,
            costo1:0,
            costo2:0,
            subtotal:0,
            subtotal1:0,
            subtotal2:0,
            totalrepuesto:0,
            fechaInicio:'',
            fechaFin:'',
            metodoRecepcion: 'manual',
            firmaDigital: null,
            firmaGuardada: false,
            nombreFirmante: '',
            cargoFirmante: '',
            usuarioRecibe: '',
            imagenFirma: null,
            nombreFirmaImagen: '',
            cargoFirmaImagen: '',
        };
         this.canvasRef = React.createRef();
    };


    componentDidMount(){
      this.props.getProgMtosInfraClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
      if (this.props.user && this.props.user.credentials && this.props.user.credentials.handle) {
                this.props.getRepuestos(this.props.user.credentials.handle);
            }
      window.addEventListener('resize', this.resizeCanvas);
      }

 componentDidUpdate(prevProps, prevState) {
    // Initialize canvas when metodoRecepcion changes to "firma"
    if (prevState.metodoRecepcion !== this.state.metodoRecepcion) {
      if (this.state.metodoRecepcion === "firma" && this.canvasRef.current) {
        this.initCanvas();
      } else if (this.state.metodoRecepcion === "usuario") {
        // Load healthcare users when this method is selected
        this.props.getUsuariosAsistenciales(this.props.clienteId);
      }
    }
  }

  componentWillUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.resizeCanvas);
  }

    // Initialize the canvas for signature
    initCanvas = () => {
      if (!this.canvasRef.current) return;
      
      const canvas = this.canvasRef.current;
      const ctx = canvas.getContext('2d');
      
      // Set up canvas
      this.resizeCanvas();
      
      // Clear the canvas
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Set up drawing state
      this.isDrawing = false;
      this.lastX = 0;
      this.lastY = 0;
      
      // Set up event listeners for drawing
      canvas.addEventListener('mousedown', this.startDrawing);
      canvas.addEventListener('mousemove', this.draw);
      canvas.addEventListener('mouseup', this.stopDrawing);
      canvas.addEventListener('mouseout', this.stopDrawing);
      
      // Touch events
      canvas.addEventListener('touchstart', this.startDrawingTouch);
      canvas.addEventListener('touchmove', this.drawTouch);
      canvas.addEventListener('touchend', this.stopDrawing);
    }

      // Resize canvas to fit container
    resizeCanvas = () => {
      if (!this.canvasRef.current) return;
      
      const canvas = this.canvasRef.current;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const container = canvas.parentElement;
      
      canvas.width = container.clientWidth * ratio;
      canvas.height = 200 * ratio;
      canvas.style.width = `${container.clientWidth}px`;
      canvas.style.height = "200px";
      
      const ctx = canvas.getContext("2d");
      ctx.scale(ratio, ratio);
      
      // Set drawing styles
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'black';
      
      // Fill with white background
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    // Start drawing
    startDrawing = (e) => {
      const canvas = this.canvasRef.current;
      const rect = canvas.getBoundingClientRect();
      this.isDrawing = true;
      this.lastX = e.clientX - rect.left;
      this.lastY = e.clientY - rect.top;
    }

    // Handle touch start
    startDrawingTouch = (e) => {
      e.preventDefault();
      if (e.touches.length !== 1) return;
      
      const touch = e.touches[0];
      const canvas = this.canvasRef.current;
      const rect = canvas.getBoundingClientRect();
      
      this.isDrawing = true;
      this.lastX = touch.clientX - rect.left;
      this.lastY = touch.clientY - rect.top;
    }

    // Draw on the canvas
    draw = (e) => {
      if (!this.isDrawing) return;
      
      const canvas = this.canvasRef.current;
      const ctx = canvas.getContext('2d');
      const rect = canvas.getBoundingClientRect();
      
      const currentX = e.clientX - rect.left;
      const currentY = e.clientY - rect.top;
      
      ctx.beginPath();
      ctx.moveTo(this.lastX, this.lastY);
      ctx.lineTo(currentX, currentY);
      ctx.stroke();
      
      this.lastX = currentX;
      this.lastY = currentY;
    }

    // Handle touch move
    drawTouch = (e) => {
      e.preventDefault();
      if (!this.isDrawing || e.touches.length !== 1) return;
      
      const touch = e.touches[0];
      const canvas = this.canvasRef.current;
      const ctx = canvas.getContext('2d');
      const rect = canvas.getBoundingClientRect();
      
      const currentX = touch.clientX - rect.left;
      const currentY = touch.clientY - rect.top;
      
      ctx.beginPath();
      ctx.moveTo(this.lastX, this.lastY);
      ctx.lineTo(currentX, currentY);
      ctx.stroke();
      
      this.lastX = currentX;
      this.lastY = currentY;
    }

    // Stop drawing
    stopDrawing = () => {
      this.isDrawing = false;
    }

      // Clear digital signature
  clearSignature = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Clear canvas
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    this.setState({ firmaDigital: null });
  }

  // Check if canvas is empty
  isCanvasEmpty = () => {
    if (!this.canvasRef.current) return true;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    
    // Check if all pixel data is white (255, 255, 255, 255)
    for (let i = 0; i < pixelData.length; i += 4) {
      // Check RGB values (skip alpha)
      if (pixelData[i] !== 255 || pixelData[i + 1] !== 255 || pixelData[i + 2] !== 255) {
        return false; // Found a non-white pixel
      }
    }
    
    return true; // Canvas is empty (all white)
  }

  // Save digital signature
  saveSignature = () => {
    if (!this.canvasRef.current) return;
    
    if (!this.isCanvasEmpty()) {
      const signatureData = this.canvasRef.current.toDataURL('image/png');
      
      // Save signature and set firmaGuardada to true
      this.setState({ 
        firmaDigital: signatureData,
        firmaGuardada: true, // Visual indicator that the signature was saved
        errors: {
          ...this.state.errors,
          firmaDigital: null
        }
      });
      
      // Show confirmation message that disappears after a few seconds
      setTimeout(() => {
        this.setState({ firmaGuardada: false });
      }, 3000);
    } else {
      // Show error - empty signature
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          firmaDigital: "Es necesario firmar antes de guardar"
        }
      }));
    }
  }

  // Handle image upload
  handleImageButtonClick = () => {
    // Create a temporary file input
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    
    // Set up the event handler before activating the input
    fileInput.addEventListener('change', (event) => {
      const file = event.target.files[0];
      if (file) {
        this.setState({ uploadingImage: true });
        
        const reader = new FileReader();
        
        reader.onload = (e) => {
          this.setState({ 
            imagenFirma: e.target.result,
            uploadingImage: false,
            errors: {
              ...this.state.errors,
              imagenFirma: null
            }
          });
        };
        
        reader.onerror = () => {
          this.setState({ 
            uploadingImage: false,
            errors: {
              ...this.state.errors,
              imagenFirma: "Error al cargar la imagen"
            }
          });
        };
        
        reader.readAsDataURL(file);
      }
    });
    
    // Simulate clicking the input
    fileInput.click();
  }

  getUserInfo = (userId, field) => {
    const { usuariosAsistenciales } = this.props.user;
    
    if (!usuariosAsistenciales) return '';
    
    const user = usuariosAsistenciales.find(u => u.idUsuario === userId);
    
    // If the field is 'cargo' but doesn't exist, provide a default value
    if (field === 'cargo' && (!user || !user[field])) {
      return 'Asistencial';
    }
    
    return user ? user[field] : '';
  }
    
      handleFiltrar = () => {
        console.log(this.state.fechaFin, this.state.fechaFin)
        this.props.getProgMtosInfraClienteFiltrado(this.props.clienteId, moment(this.state.fechaInicio).format('DD/MM/YYYY'), moment(this.state.fechaFin).format('DD/MM/YYYY'))
      }
    
      static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
           newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }
     

    handleOpen=(rawdata)=>{
       

        this.setState({open:true,
            areaid:rawdata.areaid,
            fechainicio:rawdata.fecha,
            duracion:rawdata.duracion,
            taskElectrica:rawdata.taskElectrica,
            taskHidraulica:rawdata.taskHidraulica,
            taskComunicaciones:rawdata.taskComunicaciones,
            taskGases:rawdata.taskGases,
            taskInstalaciones:rawdata.taskInstalaciones,
            horainicio:rawdata.hora,
            fechafinal:rawdata.fecha,
            progid:rawdata.progMtoId
            ,errors:{},aprobado:{}
            });

            console.log('Area ID en el Open'+rawdata.areaid)
              if (this.props.user && this.props.user.credentials) {
                  const { credentials } = this.props.user;
                  
                  if (credentials.tipouser === "Tecnico") {
                      // Si es técnico, usar handleuser para obtener repuestos
                      console.log('Es Tecnico')
                      console.log('Handle User'+credentials.handleuser);
                      if (credentials.handleuser) {
                          this.props.getRepuestos(credentials.handleuser);
                      }
                  } else if (credentials.tipouser === "Ingeniero") {
                    console.log('Es Ingeniero')
                      // Si es ingeniero, usar handle para obtener repuestos
                      if (credentials.handle) {
                          this.props.getRepuestos(credentials.handle);
                      }
                  }
              }
              
    
        };

     handleClose=()=>{
           // this.props.clearErrors();
           if(this.state.aprobado.mensaje){
              //this.handleEditProgMto();
              //get prog mtos 
              this.props.getProgMtosInfraClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
              this.setState({open:false,errors:{},aprobado:{}});
           }else{
            this.setState({open:false,errors:{},aprobado:{}});
           }
            
            };

    
     handleOpenDelete=(rawdataprogid)=>{
    
                this.setState({opendelete:true,progid:rawdataprogid,errors:{},aprobado:{}});
               
                };
        
    handleCloseDelete=()=>{

        if(this.state.aprobado.mensaje){
            //this.handleEditProgMto();
            //get prog mtos 
            this.props.getProgMtosInfraClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");
            this.setState({opendelete:false,errors:{},aprobado:{}});
         }else{
          this.setState({opendelete:false,errors:{},aprobado:{}});
         }
                   // this.props.clearErrors();
    };
    handleDelete=()=>{
      const {credentials}=this.props.user;
      if(credentials.tipouser==="Tecnico"){
        console.log("Mantenimiento borrado desde:"+credentials.tipouser)
        console.log("Perfil de Ingenieria"+credentials.handleuser)
        //mandar el user de ingenieria
        console.log("Prog id"+this.state.progid)
        this.props.deleteProgMtoInfra(this.state.progid);
        
       // this.handleEditProgMto(this.state.progid); 
            }else{
              //mandar el handle user normal 
              console.log("Mantenimiento enviado desde:"+credentials.tipouser)
              console.log("Perfil de Ingenieria"+credentials.handle)
              console.log("Prog id"+this.state.progid)
              this.props.deleteProgMtoInfra(this.state.progid);
              //this.handleEditProgMto(this.state.progid); 
            }
     
     
    
  
    }

   handleChange=(event)=>{
     this.setState({ [event.target.name]:event.target.value});

     if (event.target.name === 'repuestoId' || event.target.name === 'repuestoId1' || event.target.name === 'repuestoId2') {
      const repuestoSeleccionado = this.props.data.repuestos.find(
          repuesto => repuesto.repuestoId === event.target.value
      );
      
      if (repuestoSeleccionado) {
          let nombreField, costoField;
          
          if (event.target.name === 'repuestoId') {
              nombreField = 'nombrerepuesto';
              costoField = 'costo';
          } else if (event.target.name === 'repuestoId1') {
              nombreField = 'nombrerepuesto1';
              costoField = 'costo1';
          } else {
              nombreField = 'nombrerepuesto2';
              costoField = 'costo2';
          }
          
          this.setState({ 
              [nombreField]: repuestoSeleccionado.nombre,
              [costoField]: repuestoSeleccionado.valorunitario 
          });
      }
  }
                                
    };

      handleMethodChange = (event) => {
        const method = event.target.value;
        this.setState({ metodoRecepcion: method });
        
        // If user selection is chosen, load the list of healthcare users
        if (method === 'usuario') {
          this.props.getUsuariosAsistenciales(this.props.clienteId);
        }
      }
    
 

    handlePostMto=()=>{
   
      const {credentials}=this.props.user;

      // Determine which reception method to use and prepare the data accordingly
    let receptorInfo = {};
    
    switch(this.state.metodoRecepcion) {
      case 'manual':
        receptorInfo = {
          firmarecibe: this.state.firmarecibe,
          cargorecibe: this.state.cargorecibe,
          metodoRecepcion: 'manual'
        };
        break;
          
      case 'firma':
        // Get the signature data from the canvas
        if (this.canvasRef.current && !this.isCanvasEmpty()) {
          const signatureData = this.canvasRef.current.toDataURL('image/png');
            
          receptorInfo = {
            nombreFirmante: this.state.nombreFirmante,
            cargoFirmante: this.state.cargoFirmante,
            firmaDigital: signatureData,
            metodoRecepcion: 'firma'
          };
        } else {
          // Show error if no signature
          this.setState(prevState => ({
            errors: {
              ...prevState.errors,
              firmaDigital: "Es necesario firmar antes de guardar"
            }
          }));
          return; // Exit without submitting
        }
        break;
          
      case 'usuario':
        if (this.state.usuarioRecibe) {
          receptorInfo = {
            usuarioRecibe: this.state.usuarioRecibe,
            metodoRecepcion: 'usuario'
          };
        } else {
          // Show error if no user selected
          this.setState(prevState => ({
            errors: {
              ...prevState.errors,
              usuarioRecibe: "Debe seleccionar un usuario"
            }
          }));
          return; // Exit without submitting
        }
        break;
          
      case 'imagen':
        if (this.state.imagenFirma) {
          receptorInfo = {
            nombreFirmaImagen: this.state.nombreFirmaImagen,
            cargoFirmaImagen: this.state.cargoFirmaImagen,
            imagenFirma: this.state.imagenFirma,
            metodoRecepcion: 'imagen'
          };
        } else {
          // Show error if no image uploaded
          this.setState(prevState => ({
            errors: {
              ...prevState.errors,
              imagenFirma: "Se requiere una imagen de firma"
            }
          }));
          return; // Exit without submitting
        }
        break;
          
      default:
        receptorInfo = {
          firmarecibe: this.state.firmarecibe,
          cargorecibe: this.state.cargorecibe,
          metodoRecepcion: 'manual'
        };
    }
       const newMtoPreventivo={
            fechainicio:this.state.fechainicio,
            horainicio:this.state.horainicio,
            fechafinal:this.state.fechafinal,
            horafinal:this.state.horafinal,
            duracion:this.state.duracion,
            taskElectrica:this.state.taskElectrica,
            taskHidraulica:this.state.taskHidraulica,
            taskComunicaciones:this.state.taskComunicaciones,
            taskGases:this.state.taskGases,
            taskInstalaciones:this.state.taskInstalaciones,
            observaciones:this.state.observaciones,
            firmarecibe:this.state.firmarecibe,
            cargorecibe:this.state.cargorecibe,
            areaid:this.state.areaid,
            repuestoId:this.state.repuestoId,
            repuestoId1: this.state.repuestoId1,
            repuestoId2: this.state.repuestoId2,
            nombrerepuesto:this.state.nombrerepuesto,
            nombrerepuesto1:this.state.nombrerepuesto1,
            nombrerepuesto2:this.state.nombrerepuesto2,
            cantidad:this.state.cantidad,
            cantidad1:this.state.cantidad1,
            cantidad2:this.state.cantidad2,
            costo:this.state.costo,
            costo1:this.state.costo1,
            costo2:this.state.costo2,
            subtotal:this.state.subtotal,
            subtotal1:this.state.subtotal1,
            subtotal2:this.state.subtotal2,
            totalrepuesto:this.state.totalrepuesto,
            ...receptorInfo 
       
           
    };

    if(credentials.tipouser==="Tecnico"){
      console.log("Mantenimiento enviado desde:" + credentials.tipouser);
      console.log("Perfil de Ingenieria" + credentials.handleuser);
      this.props.postMtoInfra(newMtoPreventivo,this.state.areaid,this.props.clienteId,credentials.handleuser,this.state.progid,);  //postMtoTabla
       
        }else{
          //mandar el handle user normal 
          console.log("Mantenimiento enviado desde:" + credentials.tipouser);
          console.log("Perfil de Ingenieria" + credentials.handle);
          //mandar el user de ingenieria
          console.log("CLiente id"+this.props.clienteId)
          console.log("Prog id"+this.state.progid)
          console.log('Area Id'+this.state.areaid);
          console.log(newMtoPreventivo);
         //(newpmto,areaid,clienteid,handleuser,progid)
         this.props.postMtoInfra(newMtoPreventivo,this.state.areaid,this.props.clienteId,credentials.handle,this.state.progid,);  //postMtoTabla
        }
 
      
      

    }

    handleGoBack = () => {
      const { clienteId } = this.props.clienteId;
      const { credentials } = this.props.user;
      
      // Redirigir según el tipo de usuario
      if (credentials.tipouser === "Tecnico") {
        this.props.history.push(`/dashboard/perfilcliente/${clienteId}/infraestructura`);
      } else {
        // Asumimos que es "Ingeniero" u otro tipo
        this.props.history.push(`/dashboard/perfilcliente/${clienteId}/infraestructura`);
      }
    };
 
    
     
    
    render() {
        const {progmtosinfra,loadingmto}= this.props.datainfra; 
        const { repuestos } = this.props.data;
      
        const {errors}=this.state;
      
        const { UI:{loading}}=this.props; 

        this.state.subtotal=this.state.cantidad*this.state.costo;
        this.state.subtotal1=this.state.cantidad1*this.state.costo1;
        this.state.subtotal2=this.state.cantidad2*this.state.costo2;
        this.state.totalrepuesto=this.state.subtotal+this.state.subtotal1+this.state.subtotal2; 
         // Opciones de repuestos para los selects
        const repuestosOptions = repuestos && repuestos.length > 0 ? (
              repuestos.map(repuesto => (
                  <MenuItem key={repuesto.repuestoId} value={repuesto.repuestoId}>
                      {repuesto.nombre}
                  </MenuItem>
              ))
          ) : (
              <MenuItem value=""><em>No hay repuestos disponibles</em></MenuItem>
          );

        const datosOrdenados = progmtosinfra.slice().sort((a, b) => {
          // Primero comparamos por fecha (de más reciente a más antigua)
          const fechaDiff = moment(b.fecha, "YYYY-MM-DD").diff(moment(a.fecha, "YYYY-MM-DD"));
          
          // Si las fechas son diferentes, devolvemos la diferencia
          if (fechaDiff !== 0) return fechaDiff;
          
          // Si las fechas son iguales, ordenamos alfabéticamente por servicio
          return a.servicio.localeCompare(b.servicio);
        });
        const tableIcons = {
            Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
            Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
            Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
            Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
            DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
            Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
            Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
            Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
            FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
            LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
            NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
            PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
            ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
            Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
            SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
            ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
            ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
          };
        
        const columns=[
            {title:'Area',field:'nombre'},
            { 
              title: 'Servicio', 
              field: 'servicio' },
            {title:'Ubicación',field:'ubicacion'},
            {
              title: 'Fecha',
              field: 'fecha',
              defaultSort: 'asc',
              customSort: (a, b) =>
                moment(b.fecha, "YYYY-MM-DD").diff(moment(a.fecha, "YYYY-MM-DD"))
            },
            {title:'Mes',field:'mesnombre'},
           
            {title:'Estado',field:'estado'},
            { 
                title: 'Actividades', 
                render: rowData => `${rowData.taskElectrica}, ${rowData.taskGases}, ${rowData.taskComunicaciones}, ${rowData.taskHidraulica}, ${rowData.taskInstalaciones}`, 
                // Reemplaza variable1, variable2, variable3 con los nombres de las variables que deseas combinar
              },
           
        ]


        
     let mapeoprogmtos=!loadingmto?(
         <div>
          <div className='div-container-links-infra'>
          <PlanMtoCronoAuto clienteId={this.props.clienteId}></PlanMtoCronoAuto>
          <PlanMtoIndicadoresDialog clienteId={this.props.clienteId}></PlanMtoIndicadoresDialog>
          <Fragment>
                        <Link className='div-card-link' to={`/dashboard/perfilcliente/${this.props.clienteId}/planmtoinfra/pdf`} >
                          <div className="dashing-cardcontent">
                                              <div className="dashing-cardtext">
                                                  <p className="dashing-text-card">
                                                 Ver Cronograma en PDF
                                                  </p>
                              
                                              </div>
                                              <div className="dashing-cardicon-green">
                                                  <FaFilePdf color="#FFFFFF" className="dashing-icon"/>
                                              </div>
                                          </div>


                        </Link>
                        </Fragment>
          </div>

<div className='div-container-tecno-prestador'>
          <div className="input_divido_tecno_cliente">
            <div className="input_divido_children_tecno">
              <TextField className="login-input-email"
                required
                type="date"
                name="fechaInicio"
                id="fechaInicio"
                label="Desde"
                value={this.state.fechaInicio}
                onChange={this.handleChange}
                fullWidth
                helperText={errors.fechaInicio}
                error={errors.fechaInicio ? true : false}
                InputLabelProps={{
                  shrink: true,
                }}
                
              />
            </div>
            <div className="input_divido_children_tecno">
              <TextField className="login-input-email"
                required
                type="date"
                name="fechaFin"
                id="fechaFin"
                label="Hasta"
                value={this.state.fechaFin}
                onChange={this.handleChange}
                fullWidth
                helperText={errors.fechaFin}
                error={errors.fechaFin ? true : false}
                InputLabelProps={{
                  shrink: true,
                }}
                
              />
            </div>
            <div className='input_divido_tecno_boton'>
              <Button type="submit" buttonSize="btn--medium" buttonColor='blue' onClick={this.handleFiltrar}>
                Filtrar</Button>
            </div>
          </div>



        </div>
    <MaterialTable
            columns={columns}
            data={datosOrdenados}
            title={
              <h2 style={{ fontSize: '16px', color: '#03178c',fontWeight:'600' }}>Mantenimientos Preventivos Programados</h2>
            }
            icons={tableIcons}
            options={{
              sorting: true,
              initialSort: [
                  { field: 'fecha', direction: 'asc' }, // Primero ordena por fecha (más reciente primero)
                  { field: 'servicio', direction: 'asc' } // Luego ordena por servicio
              ],
              cellStyle: {
                  fontSize: 12,
                  fontWeight:500,
                  color:'#696B6D'
                
               
                },
                headerStyle: {
                  fontSize: 14,
                  fontWeight: 'bolder',
                  color:"#03178c" // Ajusta el tamaño de fuente según tus necesidades
                }
            
            }}
    
            actions={[
                
              rowData => ({
                icon: tableIcons.Add,
                tooltip: 'Hacer Mantenimiento',
                onClick: (event, rowData) => {
                    this.handleOpen(rowData);
                },
                disabled: rowData.estado==='realizado'
              })
             ,
                
                {
                  icon: tableIcons.Delete,
                  tooltip: 'Borrar Programación',
                  onClick: (event, rowData) => {
                      
                    this.handleOpenDelete(rowData.progMtoId);
                  }
                }
              ]}
    
            >
    
            </MaterialTable>

     
         </div>
           

        ):(  <div className="div_cargando">
            <CircularProgress size={50}color="primary" className="login-progress" />
            </div>);
            
       

        return (
           <div className="listamtoprog-container">
              
            <div className="listamtoprog-table">
            {mapeoprogmtos}
            </div>

            <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
            maxWidth="sm"
            >
              {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
              </div>
                
                ) : (<div>
                     <DialogTitle>Realizar Reporte de Mantenimiento Infraestructura</DialogTitle>
                     <DialogContent>
                              <form>
                    


                              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                    <h4 className="text-title-accorion">Tiempos del Mantenimiento</h4>
                </AccordionSummary>
                <AccordionDetails>
                <div className="div-accordion-container">
                <div className="div-input-doble-mtoprog">
                <TextField className="login-input-email"
                                required
                                type="date"
                                name="fechainicio"
                                id="fechainicio"
                                label="Fecha Inicio de Mantenimiento"
                                value={this.state.fechainicio}
                                onChange={this.handleChange}
                                min="2019-01-01" max="2022-01-01"
                                fullWidth
                                helperText={errors.fechainicio}
                                error={errors.fechainicio?true:false}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                />

                          <TextField className="login-input-email"
                                required
                                type="time"
                                name="horainicio"
                                id="horainicio"
                                label="Hora Inicio de Mantenimiento"
                                value={this.state.horainicio}
                                onChange={this.handleChange}
                                min="2000-01-01" max="2022-01-01"
                                fullWidth
                                helperText={errors.horainicio}
                                error={errors.horainicio?true:false}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                />
                    </div>
                    <div className="div-input-doble-mtoprog">
                <TextField className="login-input-email"
                                required
                                type="date"
                                name="fechafinal"
                                id="fechafinal"
                                label="Fecha Final del Mantenimiento"
                                value={this.state.fechafinal}
                                onChange={this.handleChange}
                                min="2019-01-01" max="2022-01-01"
                                fullWidth
                                helperText={errors.fechafinal}
                                error={errors.fechafinal?true:false}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                />

                          <TextField className="login-input-email"
                                required
                                type="time"
                                name="horafinal"
                                id="horafinal"
                                label="Hora Final del Mantenimiento"
                                value={this.state.horafinal}
                                onChange={this.handleChange}
                                min="2000-01-01" max="2022-01-01"
                                fullWidth
                                helperText={errors.horafinal}
                                error={errors.horafinal?true:false}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                />
                    </div>
                    <FormControl className="formcontrol-nuevocliente">
                                      <InputLabel>Duración Esperada en Horas</InputLabel>
                                      <Select
                                      required
                                  name="duracion"
                                  id="duracion"
                                  value={this.state.duracion}
                                      onChange={this.handleChange}
                                      fullWidth
                                      >
                                      <MenuItem value="">
                                          <em></em>
                                      </MenuItem>
                                      <MenuItem value="1">1</MenuItem>
                                      <MenuItem value="2">2</MenuItem>
                                      <MenuItem value="4">4</MenuItem>
                                      <MenuItem value="8">8</MenuItem>
                                      <MenuItem value="12">12</MenuItem>
                                      <MenuItem value="24">24</MenuItem>
                                      <MenuItem value="48">48</MenuItem>
                                      <MenuItem value="72">72</MenuItem>
                                      <MenuItem value="96">96</MenuItem>
                                  
                                      </Select>
                                      <FormHelperText>{errors.duracion}</FormHelperText>
                                  </FormControl>  
                    </div>
                    </AccordionDetails>
                    </Accordion>


                    <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                    <h4 className="text-title-accorion">Actividades Realizadas</h4>
                </AccordionSummary>
                <AccordionDetails>
                <div className="div-accordion-container">
                <TextField className="login-input-email"
                                required
                                type="text"
                                name="taskElectrica"
                                id="taskElectrica"
                                label="Actividades de Red Electrica y Luminarias"
                                value={this.state.taskElectrica}
                                onChange={this.handleChange}
                                fullWidth
                                helperText={errors.taskElectrica}
                                error={errors.taskElectrica?true:false}
                                multiline
                                minRows={3}
                                                
                              
                                />

<TextField className="login-input-email"
                                required
                                type="text"
                                name="taskHidraulica"
                                id="taskHidraulica"
                                label="Actividades de Red Hidraulica y Sanitaria"
                                value={this.state.taskHidraulica}
                                onChange={this.handleChange}
                                fullWidth
                                helperText={errors.taskHidraulica}
                                error={errors.taskHidraulica?true:false}
                                multiline
                                minRows={3}
                                                
                              
                                />

<TextField className="login-input-email"
                                required
                                type="text"
                                name="taskComunicaciones"
                                id="taskComunicaciones"
                                label="Actividades de Red Comunicaciones y Datos"
                                value={this.state.taskComunicaciones}
                                onChange={this.handleChange}
                                fullWidth
                                helperText={errors.taskComunicaciones}
                                error={errors.taskComunicaciones?true:false}
                                multiline
                                minRows={3}
                                                
                              
                                />

<TextField className="login-input-email"
                                required
                                type="text"
                                name="taskGases"
                                id="taskGases"
                                label="Actividades de Red Gases, Vapor y Otros"
                                value={this.state.taskGases}
                                onChange={this.handleChange}
                                fullWidth
                                helperText={errors.taskGases}
                                error={errors.taskGases?true:false}
                                multiline
                                minRows={3}
                                                
                              
                                />

<TextField className="login-input-email"
                                required
                                type="text"
                                name="taskInstalaciones"
                                id="taskInstalaciones"
                                label="Actividades de Instalaciones Fisicas, Pisos, Techos y Otros"
                                value={this.state.taskInstalaciones}
                                onChange={this.handleChange}
                                fullWidth
                                helperText={errors.taskInstalaciones}
                                error={errors.taskInstalaciones?true:false}
                                multiline
                                minRows={3}
                                                
                              
                                />
                    </div>
                    </AccordionDetails>
                    </Accordion>

                    <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h4 className="text-title-accorion">Observaciones</h4>
                </AccordionSummary>
                <AccordionDetails>
                <TextField className="login-input-email"
                              
                              multiline
                              type="Text"
                              name="observaciones"
                              id="observaciones"
                              label="Observaciones"
                              rows={4}
                              value={this.state.observaciones}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.observaciones}
                              error={errors.observaciones?true:false}
                          
                              />
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h4 className="text-title-accorion">Materiales Usados</h4>
                </AccordionSummary>
                <AccordionDetails>
                <div className="div-accordion-container">
                                  {/* Primer repuesto */}
                                  <div className="repuestos-fila">
                                      <div className="repuesto-columna-nombre">
                                          <FormControl className="repuesto-selector" fullWidth>
                                              <InputLabel>Repuesto</InputLabel>
                                              <Select
                                                  name="repuestoId"
                                                  id="repuestoId"
                                                  value={this.state.repuestoId}
                                                  onChange={this.handleChange}
                                                  fullWidth
                                              >
                                                  <MenuItem value=""><em>Seleccione un repuesto</em></MenuItem>
                                                  {repuestosOptions}
                                              </Select>
                                              <FormHelperText>{errors.repuestoId}</FormHelperText>
                                          </FormControl>
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Number"
                                              name="cantidad"
                                              id="cantidad"
                                              label="Cantidad"
                                              value={this.state.cantidad}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.cantidad}
                                              error={errors.cantidad?true:false}
                                          />
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Text"
                                              name="costo"
                                              id="costo"
                                              label="Costo"
                                              value={this.state.costo}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.costo}
                                              error={errors.costo?true:false}
                                              InputProps={{
                                                  readOnly: true,
                                              }}
                                          />
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Text"
                                              name="subtotal"
                                              id="subtotal"
                                              label="subtotal"
                                              value={this.state.subtotal}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.subtotal}
                                              error={errors.subtotal?true:false}
                                              InputProps={{
                                                  readOnly: true,
                                              }}
                                          />
                                      </div>
                                  </div>
                              
                                  {/* Segundo repuesto */}
                                  <div className="repuestos-fila">
                                      <div className="repuesto-columna-nombre">
                                          <FormControl className="repuesto-selector" fullWidth>
                                              <InputLabel>Repuesto</InputLabel>
                                              <Select
                                                  name="repuestoId1"
                                                  id="repuestoId1"
                                                  value={this.state.repuestoId1}
                                                  onChange={this.handleChange}
                                                  fullWidth
                                              >
                                                  <MenuItem value=""><em>Seleccione un repuesto</em></MenuItem>
                                                  {repuestosOptions}
                                              </Select>
                                              <FormHelperText>{errors.repuestoId1}</FormHelperText>
                                          </FormControl>
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Number"
                                              name="cantidad1"
                                              id="cantidad1"
                                              label="Cantidad"
                                              value={this.state.cantidad1}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.cantidad1}
                                              error={errors.cantidad1?true:false}
                                          />
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Text"
                                              name="costo1"
                                              id="costo1"
                                              label="Costo"
                                              value={this.state.costo1}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.costo1}
                                              error={errors.costo1?true:false}
                                              InputProps={{
                                                  readOnly: true,
                                              }}
                                          />
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Text"
                                              name="subtotal1"
                                              id="subtotal1"
                                              label="subtotal"
                                              value={this.state.subtotal1}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.subtotal1}
                                              error={errors.subtotal1?true:false}
                                              InputProps={{
                                                  readOnly: true,
                                              }}
                                          />
                                      </div>
                                  </div>
                              
                                  {/* Tercer repuesto */}
                                  <div className="repuestos-fila">
                                      <div className="repuesto-columna-nombre">
                                          <FormControl className="repuesto-selector" fullWidth>
                                              <InputLabel>Repuesto</InputLabel>
                                              <Select
                                                  name="repuestoId2"
                                                  id="repuestoId2"
                                                  value={this.state.repuestoId2}
                                                  onChange={this.handleChange}
                                                  fullWidth
                                              >
                                                  <MenuItem value=""><em>Seleccione un repuesto</em></MenuItem>
                                                  {repuestosOptions}
                                              </Select>
                                              <FormHelperText>{errors.repuestoId2}</FormHelperText>
                                          </FormControl>
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Number"
                                              name="cantidad2"
                                              id="cantidad2"
                                              label="Cantidad"
                                              value={this.state.cantidad2}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.cantidad2}
                                              error={errors.cantidad2?true:false}
                                          />
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Text"
                                              name="costo2"
                                              id="costo2"
                                              label="Costo"
                                              value={this.state.costo2}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.costo2}
                                              error={errors.costo2?true:false}
                                              InputProps={{
                                                  readOnly: true,
                                              }}
                                          />
                                      </div>
                                      <div className="repuesto-columna">
                                          <TextField 
                                              className="repuesto-campo"
                                              type="Text"
                                              name="subtotal2"
                                              id="subtotal2"
                                              label="Subtotal"
                                              value={this.state.subtotal2}
                                              onChange={this.handleChange}
                                              fullWidth
                                              helperText={errors.subtotal2}
                                              error={errors.subtotal2?true:false}
                                              InputProps={{
                                                  readOnly: true,
                                              }}
                                          />
                                      </div>
                                  </div>
                              
                                  <div>
                                      <a>Total: ${this.state.totalrepuesto}</a>
                                  </div>
                              </div>

                </AccordionDetails>
              </Accordion>

      
  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <h4 className="text-title-accorion">Personal que recibe la actividad</h4>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="div-accordion-container">
                        {/* Method selection */}
                        <FormControl className="formcontrol-nuevomto" fullWidth>
                          <InputLabel>Método de recepción</InputLabel>
                          <Select
                            name="metodoRecepcion"
                            id="metodoRecepcion"
                            value={this.state.metodoRecepcion || "manual"}
                            onChange={(e) => {
                              this.handleChange(e);
                              this.handleMethodChange(e);
                            }}
                            fullWidth
                          >
                            <MenuItem value="manual">Ingreso manual</MenuItem>
                            <MenuItem value="firma">Firma digital</MenuItem>
                            <MenuItem value="usuario">Seleccionar usuario</MenuItem>
                            <MenuItem value="imagen">Cargar imagen</MenuItem>
                          </Select>
                          <FormHelperText>{errors.metodoRecepcion}</FormHelperText>
                        </FormControl>

                        {/* Different components based on selection */}
                        {this.state.metodoRecepcion === "manual" || !this.state.metodoRecepcion ? (
                          <div className="div-firma-digital">
                            <TextField 
                              className="login-input-email"
                              required
                              type="Text"
                              name="firmarecibe"
                              id="firmarecibe"
                              label="Nombre de Quien Recibe La Actividad"
                              value={this.state.firmarecibe}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.firmarecibe}
                              error={errors.firmarecibe ? true : false}
                            />

                            <TextField 
                              className="login-input-email"
                              required
                              type="Text"
                              name="cargorecibe"
                              id="cargorecibe"
                              label="Cargo de Quien Recibe la Actividad"
                              value={this.state.cargorecibe}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.cargorecibe}
                              error={errors.cargorecibe ? true : false}
                            />
                          </div>
                        ) : this.state.metodoRecepcion === "firma" ? (
                          <div className="div-firma-digital">
                            <div className="firma-canvas-container">
                              <canvas 
                                ref={this.canvasRef}
                                id="firma-digital-canvas" 
                                className="firma-canvas"
                                width="500" 
                                height="200"
                              />
                            </div>
                            <div className="div-firma-buttons">
                              <Button 
                                variant="outlined"
                                onClick={this.clearSignature}
                                className="btn-limpiar-firma"
                              >
                                Limpiar firma
                              </Button>
                              <Button 
                                variant="contained"
                                onClick={this.saveSignature}
                                className="btn-guardar-firma"
                              >
                                Guardar firma
                              </Button>
                            </div>
                            {/* Indicador de firma guardada */}
                            {this.state.firmaGuardada && (
                              <div className="firma-guardada-indicador" style={{ 
                                color: '#20B90C', 
                                marginTop: '10px', 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center' 
                              }}>
                                <FaCheckCircle style={{ marginRight: '5px' }} />
                                <span>Firma guardada correctamente</span>
                              </div>
                            )}
                            <TextField 
                              className="login-input-email mt-2"
                              required
                              type="Text"
                              name="nombreFirmante"
                              id="nombreFirmante"
                              label="Nombre del firmante"
                              value={this.state.nombreFirmante}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.nombreFirmante}
                              error={errors.nombreFirmante ? true : false}
                            />
                            <TextField 
                              className="login-input-email"
                              required
                              type="Text"
                              name="cargoFirmante"
                              id="cargoFirmante"
                              label="Cargo del firmante"
                              value={this.state.cargoFirmante}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.cargoFirmante}
                              error={errors.cargoFirmante ? true : false}
                            />
                          </div>
                        ) : this.state.metodoRecepcion === "usuario" ? (
                          <div className="div-seleccion-usuario">
                            <FormControl className="formcontrol-nuevomto" fullWidth>
                              <InputLabel>Usuario que recibe</InputLabel>
                              <Select
                                name="usuarioRecibe"
                                id="usuarioRecibe"
                                value={this.state.usuarioRecibe || ""}
                                onChange={this.handleChange}
                                fullWidth
                              >
                                <MenuItem value=""><em>Seleccione un usuario</em></MenuItem>
                                {this.props.user.usuariosAsistenciales && this.props.user.usuariosAsistenciales.map(user => (
                                  <MenuItem key={user.idUsuario} value={user.idUsuario}>
                                    {user.nombre} {user.cargo ? `- ${user.cargo}` : ''}
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText>{errors.usuarioRecibe}</FormHelperText>
                            </FormControl>
                            {this.state.usuarioRecibe && (
                              <div className="div-usuario-info" style={{
                                marginTop: '10px',
                                padding: '10px',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '4px'
                              }}>
                                <p className="usuario-info-nombre">
                                  <strong>Nombre: </strong> 
                                  {this.getUserInfo(this.state.usuarioRecibe, 'nombre')}
                                </p>
                                <p className="usuario-info-cargo">
                                  <strong>Cargo: </strong> 
                                  {this.getUserInfo(this.state.usuarioRecibe, 'cargo')}
                                </p>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="div-carga-imagen">
                            <Button
                              variant="contained"
                              onClick={this.handleImageButtonClick}
                              disabled={this.state.uploadingImage}
                              className="btn-guardar-firma"
                            >
                              {this.state.uploadingImage ? 'Procesando...' : 'Cargar imagen de firma'}
                            </Button>

                            {this.state.imagenFirma && (
                              <div className="div-preview-imagen">
                                <img 
                                  src={this.state.imagenFirma} 
                                  alt="Vista previa de firma" 
                                  className="preview-imagen-firma"
                                  style={{ maxWidth: '100%', maxHeight: '200px', marginTop: '10px' }}
                                />
                              </div>
                            )}
                            <TextField 
                              className="login-input-email mt-2"
                              required
                              type="Text"
                              name="nombreFirmaImagen"
                              id="nombreFirmaImagen"
                              label="Nombre del firmante"
                              value={this.state.nombreFirmaImagen}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.nombreFirmaImagen}
                              error={errors.nombreFirmaImagen ? true : false}
                            />
                            <TextField 
                              className="login-input-email"
                              required
                              type="Text"
                              name="cargoFirmaImagen"
                              id="cargoFirmaImagen"
                              label="Cargo del firmante"
                              value={this.state.cargoFirmaImagen}
                              onChange={this.handleChange}
                              fullWidth
                              helperText={errors.cargoFirmaImagen}
                              error={errors.cargoFirmaImagen ? true : false}
                            />
                          </div>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                             
                      

                    

                                 




                      </form>
                      </DialogContent>
                </div>
               
                )}
            
            

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Realizar Mantenimiento" onClick={this.handlePostMto}>
                    <FaPlus color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
           </DialogActions>

            </Dialog>
          
           
           
            <Dialog
             open={this.state.opendelete}
             onClose={this.handleCloseDelete}
             fullWidth
            maxWidth="sm"
            >

            {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-delete'>
                    <FaTrash color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Borrado Exitosamente</h2>
              </div>
                
                ):(<div>
                <DialogTitle>¿Estás seguro de borrar programación de Mto?</DialogTitle>
                </div>)}
            

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleCloseDelete}>
                    <FaCheckCircle color="#f9044e" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Borrar Programación" onClick={this.handleDelete}>
                    <FaTrash color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
           </DialogActions>
            </Dialog>
        
           </div>

         
        )
    }
}

PlanMtoPerfilTabla.propTypes = {
  getRepuestos:PropTypes.func.isRequired,
   getUsuariosAsistenciales:PropTypes.func.isRequired,
    postMtoInfra:PropTypes.func.isRequired,
    getProgMtosInfraCliente: PropTypes.func.isRequired,
    getProgMtosInfraClienteFiltrado: PropTypes.func.isRequired,
    user:PropTypes.object.isRequired,    
    data:PropTypes.object.isRequired,
    datainfra:PropTypes.object.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
    deleteProgMtoInfra:PropTypes.func.isRequired,
    
  };

const mapActionsToProps={getRepuestos, getUsuariosAsistenciales,postMtoInfra,getProgMtosInfraCliente,clearErrors,deleteProgMtoInfra,getProgMtosInfraClienteFiltrado};

const mapStateToProps = (state)=>({
    data:state.data,
    datainfra:state.datainfra,
    user:state.user,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(PlanMtoPerfilTabla);



